<a (click)="onCloseClick()">
  {{ 'GENERAL.BUTTON.CLOSE' | translate }}
</a>

<a *ngIf="tileNavigationActionItem.visible$ | async" (click)="onNavigationClick()">
  {{ tileNavigationActionItem.label }} ->
</a>
